(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glintac-most-wanted"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__glintacMostWantedInit) return;
  window.__glintacMostWantedInit = true;
  function update(track) {
    var w = track.clientWidth;
    if (!w) return;
    var index = Math.round(track.scrollLeft / w);
    var product = track.closest('.glintac-most-wanted__product');
    if (!product) return;
    var dots = product.querySelectorAll('.glintac-most-wanted__dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('glintac-most-wanted__dot--active', i === index);
    }
  }
  // One delegated, passive listener for every product image carousel (scroll doesn't bubble, so capture)
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('glintac-most-wanted__media-carousel')) return;
    if (t.__gmwRaf) return;
    t.__gmwRaf = requestAnimationFrame(function () {
      t.__gmwRaf = 0;
      update(t);
    });
  }, { capture: true, passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
